import SearchGradientIcon from 'ui-components/SearchGradientIcon';
import React from 'react'
import BreadcrumbHeader from 'layout/BreadcrumbsHeader'
import { useTheme } from '@emotion/react'
import ThemeBGWrapper from 'ui-components/ThemeBGWrapper'
import { Box,Grid,useMediaQuery } from '@mui/material'
import { makeStyles } from "@mui/styles"
import { TabContext } from '@mui/lab'
import CustomTabs from 'ui-components/CustomTabs'
import {  Search } from '@mui/icons-material'
import Cookies from 'js-cookie'
import AllInvestors from './AllInvestors'
import Shortlisted from './Shortlisted'
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import CustomInputField from 'ui-components/CustomInputField'
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import { Primary } from 'ui-components/Buttons';
const useStyles = makeStyles((theme) => ({
  scrollTabs: {
    "&": {
      padding: "3rem"
    }
  }
}));

const FindInvestors = () => {
  const theme = useTheme();
  const classes = useStyles();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const investorsTab = [
    { value: "all_investors", label: 'Matched', count: 10, read: false, icon: CheckOutlinedIcon },
    { value: "shortlisted", label: 'Shortlisted', count: 10, read: false, icon: TaskOutlinedIcon },
    // { value: "shared_pitchdeck", label: 'PitchDeck Shared', count: 10, read: false, icon: ShareRounded },
    // { value: "archived", label: 'Archived', count: 10, read: false, icon: ArchiveOutlined },
]
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(10);
  const [sort, setSort] = React.useState(-1);
  // const [nameSerch, setNameSerch] = React.useState("");
  const [count , setCount] =React.useState(0);
  const parsedCookieForQueryParams = Cookies.get("backrr_investors_query") ? JSON.parse(Cookies.get("backrr_investors_query")) : {}
  const [queryParams, setQueryParams] = React.useState(parsedCookieForQueryParams);
  const [stage, setStage] = React.useState(null);
  const [category, setCategory] = React.useState(null);
  const [sector, setSector] = React.useState(null);
  const parsedCookieForStatus = Cookies.get("backrr_investors_status") || "all_investors"
  const [value, setValue] = React.useState(parsedCookieForStatus || "all_investors")
  const [search, setSearch] = React.useState("" || Cookies.get("search_backrr_investors"));
  const [reset, setReset] = React.useState(false);
  const [searchStatus, setSearchStatus] = React.useState(false);
  const [openFilter, setOpenFilter] = React.useState(false);
  const refetchListing = () => {

  }

  const handleTabChange = (event, newValue) => {
    // console.log("value", newValue)
    setValue(newValue);
    setCount(null)
    Cookies.set("backrr_investors_status", newValue);
    setPage(1);
  };
  const [currentRow, setCurrentRow] = React.useState(null);
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const [openImportInvestorModal, setOpenImportInvestorModal] = React.useState(false);
//   const Actions = () => {
//     return <>
//       <B400 sx={{ display: 'flex', marginLeft: 'auto', background: theme.palette.customColors.indigo700, padding: "0.625rem 1rem", "& > .MuiButton-icon.MuiButton-startIcon": { marginRight: isMediumScreen ? 0 : '0.5rem', marginLeft: isMediumScreen ? 0 : '-0.25rem' } }} startIcon={<UploadFile sx={{ width: 20, height: 20 }} />} onClick={() => setOpenImportInvestorModal(true)}>{isMediumScreen ? "" : "Import"}</B400>
//     </>
//   }
  React.useEffect(() => {
    refetchListing();
  }, [reset]);

  return (
    <>
      {/* <ModalComponent open={openImportInvestorModal} onClose={handleImportInvestorClose} style={{ maxWidth: 640, width: "100%" }}>
                <ImportInvestorPopup  value={value} handleClose={handleImportInvestorClose} handleSubmit={handleImportInvestorSubmit} />
            </ModalComponent> */}
      {/* <ThemeBGWrapper bgColor={theme.palette.customColors.yellow_bg}> */}
        {/* <BreadcrumbHeader title={"Find Investors"} sx={{ paddingBottom: "0 !important" }} /> */}
        <Grid container xs={12} padding={{ xs: "0 0rem 1rem 0rem", md: "0 0rem 2rem 0rem" }} justifyContent={"space-between"}>
          <TabContext value={value}>
            <Grid container xs={12} pt={0} pb={0} spacing={0} display={"flex"} justifyContent={"space-between"} marginLeft={0} alignContent={"flex-start"} >
              {/* <Grid item xs={10} lg={10}> */}
              {/* <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"} sx={{ gap: "0.5rem" }} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }} marginRight={"0rem"} mb={1}>
                <Grid item xs={12} sm={12} md={4} lg={3} style={{ display: 'flex', height: 'min-content', alignItems: 'center', gap: "0.5rem" }}>
                  <CustomInputField
                    autoComplete="off"
                    sx={{
                      marginBottom: 0,
                      "& > .MuiFilledInput-root": {
                        borderColor: `${theme.palette.customColors.b50} !important`,
                        borderRadius: '8px'
                      }
                    }}
                    fullWidth
                    value={search}
                    name={`search_${Math.random().toString(36).substring(7)}`}  // Set a random name attribute
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        // alert(e.target.value);
                        refetchListing()
                        if (search) {
                          setSearchStatus(true)
                        }
                        setPage(1);
                      }
                    }}
                    onChange={(event) => {
                      setSearch(event.target.value);
                      Cookies.set("search_backrr_investors", event.target.value);
                      setSearchStatus(false)
                    }}
                    size="small"
                    startAdornment={<>
                      <SearchGradientIcon />
                    </>}
                    placeholder={'Search by name'}
                  />
                  <Primary onClick={() => {
                    if (searchStatus && (search !== '')) {
                      setSearch('')
                      Cookies.set("search_backrr_investors", '');
                      setReset(!reset)
                    } else {
                      refetchListing()
                    }
                    setSearchStatus((oldVal) => !oldVal)
                    setPage(1);
                  }} sx={{ display: { xs: "block", md: 'none' }, padding: ".7rem 1.25rem", bgcolor: searchStatus && (search !== '') ? "#e9f5f8" : theme.palette.customColors.b300, ":hover": { bgcolor: searchStatus && (search !== '') ? "#e9f5f8" : theme.palette.customColors.b400 }, border: `0px solid ${searchStatus && (search !== '') ? "black" : "inherit"}`, color: searchStatus && (search !== '') ? theme.palette.customColors.b300 : "white" }}  >{(searchStatus && (search !== '')) ? "Reset" : "Search"}</Primary>
                
                   <Grid item display={{ xs: "none", md: "block" }} width="25%">
                    <Primary onClick={() => {

                      if (searchStatus && (search !== '' || Object.keys(queryParams)?.length > 0)) {
                        setSearch('')
                        Cookies.set("search_backrr_investors", "");
                        setQueryParams({})
                        Cookies.set("backrr_investors_query", JSON.stringify({}));
                        setStage(null)
                        setCategory(null)
                        setSector(null);
                        // setStatus('')
                        setReset(!reset)
                      } else {
                        Cookies.set("backrr_investors_query", JSON.stringify({ ...queryParams }));
                        refetchListing()
                      }
                      setSearchStatus((oldVal) => !oldVal)
                      setPage(1);
                    }} sx={{ padding: ".7rem 1.25rem", bgcolor: (searchStatus && (search !== '' || Object.keys(queryParams)?.length > 0)) ? "#e9f5f8" : theme.palette.customColors.b300, ":hover": { bgcolor: (searchStatus && (search !== '' || Object.keys(queryParams)?.length > 0)) ? "#e9f5f8" : theme.palette.customColors.b400 }, border: `0px solid ${(searchStatus && (search !== '' || Object.keys(queryParams)?.length > 0)) ? "black" : "inherit"}`, color: (searchStatus && (search !== '' || Object.keys(queryParams)?.length > 0)) ? theme.palette.customColors.b300 : "white" }}>
                      {(searchStatus && (search !== '' || Object.keys(queryParams)?.length > 0)) ? "Reset" : "Search"}
                    </Primary>
                  </Grid>
                </Grid>
              </Grid> */}
             
              <Grid item xs={12} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }} marginRight={"0rem"} >
                <Grid xs={12} container sx={{ bgcolor: 'white', borderRadius: '8px 8px 0 0', borderInline: `1px solid ${theme.palette.customColors.b50}`, borderBlockStart: `1px solid ${theme.palette.customColors.b50}` }}>
                  <Grid width="80%">
                    <CustomTabs
                      variant="submenu"
                      titleStyle={{ fontSize: '1rem' }}
                      tabStyle={{ padding: { xs: '0.5rem 1rem 0rem' } }}
                      sx={{ border: '0px solid black !important' }}
                      tabFlexContainerSx={{ gap: { xs: '1rem', sm: '2.5rem', md: '5rem' } }}
                      bgColor={"transparent"}
                      allowScrollButtonsMobile={true}
                      data={
                        [...investorsTab?.map(item => {
                          return ({ ...item, label: `${item?.label} ${value === item?.value && count && count!== null ? `(${count})` : ""}` })
                        })]
                      } 
                      value={value} handleChange={handleTabChange}
                      isSmallScreen={isSmallScreen} className={classes.scrollTabs} key={"Tabs Tabs"} indicatorFullSize={false} />
                  </Grid>
                  <Grid width="20%" pt={0.75} pr={1} marginLeft={"auto"}>
                    {/* <Actions /> */}
                  </Grid>
                </Grid>
              </Grid>
              <Box width={"100%"} maxHeight="calc(100vh - 15.5rem)" paddingLeft={"2rem"} maxWidth={"100%"} overflow={"hidden"} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }}>
                {value === "all_investors" && (
                <AllInvestors  setCount={setCount} count={count} limit={limit} setLimit={setLimit} page={page} setPage={setPage} reset={reset} searchStatus={searchStatus} search={search} setSearch={setSearch} openImportInvestorModal={openImportInvestorModal} setOpenImportInvestorModal={setOpenImportInvestorModal}/>
                )}
                {value === "shortlisted" && (
                <Shortlisted setCount={setCount} count={count} limit={limit} setLimit={setLimit} page={page} setPage={setPage}  reset={reset} searchStatus={searchStatus} search={search} setSearch={setSearch}  openImportInvestorModal={openImportInvestorModal} setOpenImportInvestorModal={setOpenImportInvestorModal} />
                )}
            
              </Box>
            </Grid>
          </TabContext>
        </Grid>
      {/* </ThemeBGWrapper> */}
    </>
  )
}
export default FindInvestors